import { CREATEEXPENSE_SUCCESS, CREATEEXPENSE_FAIL } from "../actionTypes";

const initialState = {
    user: [],
};

const createExpenseReducer = (state = initialState, action) => {
    switch (action.type) {
        case CREATEEXPENSE_SUCCESS:
            return {
                ...state,
                isLoggedIn: true,
                user: action.payload,
            };
        case CREATEEXPENSE_FAIL:
            return {
                ...state,
                isLoggedIn: false,
                user: null,
            };
        default:
            break;
    }

    return state;
};

export default createExpenseReducer;
